export default "__VITE_ASSET__BK8LqK_1__"